/* eslint-disable quotes */
import React from 'react'
import { CardButton } from '../styles'
import { Text } from '../../../styles/Components'
import Image from 'next/image'
import ServiceImage1 from '../../../../public/home/GS_home_service_1.jpg'
import ServiceImage2 from '../../../../public/home/GS_home_service_2.jpg'
import ServiceImage3 from '../../../../public/home/GS_home_service_3.jpg'

// NOTE: asSeenImages is currently unused anywhere in the app (dead code). It is
// carried over unchanged to keep this refactor behavior-neutral; remove in a
// separate cleanup if desired.
export const asSeenImages = {
  vogue: () => (
    <Image src={require('../../../../public/images/VOGUE_LOGO.svg')} alt='GLAMSQUAD featured in Vogue' />
  ),
  refinery29: () => (
    <Image src={require('../../../../public/images/Refinery29_logo.svg')} alt='GLAMSQUAD featured in Refinery29' />
  ),
  gma: () => <Image src={require('../../../../public/images/gma.png')} alt='GLAMSQUAD featured on Good Morning America' />,
  nyt: () => <Image src={require('../../../../public/images/nyt.png')} alt='GLAMSQUAD featured in The New York Times' />,
  forbes: () => <Image src={require('../../../../public/images/forbes.png')} alt='GLAMSQUAD featured in Forbes' />,
  inStyle: () => (
    <Image src={require('../../../../public/become-a-pro/as-seen/InStyle.jpeg')} alt='GLAMSQUAD featured in InStyle' />
  )
}

export const popularServices = (redirectToBook) => ([
  {
    title: 'Blowouts, buns, and braids',
    description:
      'For hair that bounces from thing to thing, just like you.',
    price: 60,
    clickHandler: () => {
      redirectToBook({ serviceType: 'hair', name: 'blowout' })
    },
    image: () => (
      <CardButton>
        <Image
          src={ServiceImage1}
          alt='Woman with a fresh GLAMSQUAD blowout from an in-home hair service'
          style={{ objectFit: 'cover' }}
          fill
        />
        <div>
          <Text color='#FFF'>
            Book Hair
          </Text>
        </div>
      </CardButton>
    )
  },
  {
    title: 'Nail maintenance',
    short_title: 'Nails',
    description:
      'Get fresh nails right in your home, hotel, or office.',
    price: 55,
    clickHandler: () => {
      redirectToBook({ serviceType: 'nails', name: 'manicure' })
    },
    image: () => (
      <CardButton>
        <Image
          src={ServiceImage2}
          alt='Fresh manicure from a GLAMSQUAD at-home nail service'
          style={{ objectFit: 'cover' }}
          fill
        />
        <div>
          <Text color='#FFF'>
            Book Nails
          </Text>
        </div>
      </CardButton>
    )
  },
  {
    title: 'Makeup for every moment',
    short_title: 'Makeup',
    description:
      'Face events with confidence—and flawless makeup.',
    price: 95,
    clickHandler: () => {
      redirectToBook({ serviceType: 'makeup', name: 'makeup' })
    },
    image: () => (
      <CardButton>
        <Image
          src={ServiceImage3}
          alt='Professional makeup by a GLAMSQUAD at-home makeup artist'
          style={{ objectFit: 'cover' }}
          fill
        />
        <div>
          <Text color='#FFF'>
            Book Makeup
          </Text>
        </div>
      </CardButton>
    )
  }
])

export const howToBookSteps = ['Input your address', 'Choose your services', 'Select a date and time', 'Create your account', 'Get glam']

export const locations = [
  'New York City',
  'Jersey City',
  'Los Angeles',
  'Orange County',
  'Miami',
  'Fort Lauderdale',
  'Palm Beach',
  'Washington DC',
  'Boston',
  'Long Island',
  'San Diego',
  'SF/Bay Area',
  'Dallas/Fort Worth',
  'Houston',
  'Las Vegas',
  'Chicago',
  'Nashville',
  'Phoenix/Scottsdale',
  'Atlanta',
]

export const ratings = [
  {
    quote:
      '“They matched my skin tone, placed extensions expertly, and I have never looked better! They were so fun to hang out with too!”',
    name: 'Shailly P.',
  },
  {
    quote:
      '“Incredible service — both the blowout and the makeup application were perfection. Highly recommend!”',
    name: 'Jen B.',
  },
  {
    quote:
      '“I use Glamsquad for every event! They are in and out in an hour, friendly, professional, and always make me feel wonderful.”',
    name: 'Sara F.',
  },
  {
    quote:
      `“LOVED my hair and makeup! The best it's ever looked! Got so many compliments!!”`,
    name: 'Maddy M.',
  },
  {
    quote:
      '“My hairstylist was on time, professional, and did an excellent job. I had two events back to back (different days) and the style lasted for BOTH!”',
    name: 'Summer L.',
  },
  {
    quote:
      '“Hair and makeup looked gorgeous! Loved how they came right to my apartment — made the getting ready process enjoyable.”',
    name: 'Kate B.',
  },
]
